import * as d3 from 'd3'


export default {
  data() {
    return {
      //series层级分明，第一个数组是第一层，第二个数组是第二层,第二个数组的value为当前组与前面所有组条形长度总和,value_last为前面所有组条形的总长度
      bar_data: [],
      bar_columns: ["insurance_type","Environmental","Social","Governance"],
      // 折线图数据
      broken_line_data: [],
      columns: ["insurance_type", "insurance_ratio"]
    }
  },
  methods: {
    drawBarChart() {
      let margin = ({top: 10, right: 10, bottom: 20, left: 10})
      let width = 160
      let height = 100
      var color = d3.scaleOrdinal().range(["#1EA862","#F6A012","#2467F1"])

      // 柱状统计图
      var xAxis = g => g
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x_name).tickSizeOuter(0))
        .call(g=>g.selectAll("line").remove())
        .call(g=>g.select("path")
          .attr("d","M15,0.5H145")
        )
        .call(g=>g.selectAll("text")
          .attr("font-size","4px")
          .attr("color","black")
          .attr("transform", "translate(-10,0)rotate(-30)")
        )
      var yAxis = g => g
        .attr("transform", `translate(${margin.left+10},0)`)
        .call(d3.axisLeft(y).ticks(null, "s"))
        .call(g => g.selectAll(".domain").remove())
        .call(g=>g.selectAll('line').remove())
        .call(g=>g.selectAll('text')
          .attr("font-weight", "400")
          .attr("font-size", "5px"))

      var x_name =d3.scaleBand()
        .domain(this.bar_data[0].map(d => d.insurance_type))
        .rangeRound([margin.left, width - margin.right])
        .paddingInner(-0.2)
      var x = d3.scaleBand()
        .domain(d3.range(this.bar_data[0].length))
        .range([margin.left, width - margin.right])
        .padding(0.65)
      var y = d3.scaleLinear()
        .domain([0,  d3.max(this.bar_data[this.bar_data.length-1], d => d.value)]).nice()
        .range([height - margin.bottom, margin.top])

      var svg = d3.select("#esg_risk_bar_chart").append("svg").attr("viewBox", [0, 0, width, height])
      svg.append("g")
        .selectAll("g")
        .data(this.bar_data)
        .join("g")
        .attr("fill", (d,i) => color(i))
        .selectAll("rect")
        .data(d=> d)
        .join("rect")
        .attr("x", (d, i) => x(i))
        .attr("y", d => y(d.value))
        .attr("height", d => y(0) - y(d.value-d.value_last))
        .attr("width", x.bandwidth())

      let tr = ["E风险系数", "S风险系数", "G风险系数"]
      let legend = svg => {
        const g = svg
          .attr("transform", `translate(1,${height - 5})`)
          .attr("text-anchor", "end")
          .attr("font-family", "sans-serif")
          .attr("font-size", 4)
          .selectAll("g")
          .data(color.domain().slice())
          .join("g")
          .attr("transform", (d, i) => `translate(${i * 30},0)`);

        g.append("rect")
          .attr("x", 0)
          .attr("width", 5)
          .attr("height", 5)
          .attr("fill", color);

        g.append("text")
          .attr("x", 25)
          .attr("y", 4)
          .attr("dy", "0.035em")
          .text(d=>tr[d])
      }

      svg.append("g").call(xAxis)
      svg.append("g").call(yAxis)
      svg.append("g").call(legend)
      svg.node()
    },
    drawBrokenLine() {
      if (this.broken_line_data.length==0) return
      let margin = ({top: 10, right: 10, bottom: 20, left: 10})
      let width = 160
      let height = 100
      var color = d3.scaleOrdinal().range(["#e5740e","#F6A012","#2467F1"])
      let data = this.broken_line_data

      // 对折线数据按照条形图保险名称排序
      let sort_names = {}
      for(let i in this.bar_data[0]) {
        sort_names[this.bar_data[0][i].insurance_type] = i
      }
      for(let i in data){
        let name = data[i].insurance_type
        data[i]['index'] = sort_names[name]
      }
      data.sort((a,b)=>a.index-b.index)
      let series = this.columns.slice(1).map(key=>data.map(({[key] : value, index}) =>({key,index,value})))

      let x=d3.scaleLinear()
        .domain([data[0].index, data[data.length - 1].index])
        .range([margin.left + 8, width - margin.right - 8])
      let y = d3.scaleLinear()
        .domain([d3.min(series, s => d3.min(s, d => d.value)), d3.max(series, s => d3.max(s, d => d.value))]).nice()
        .range([height - margin.bottom, margin.top])

      let xAxis = g => g
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x).ticks(6).tickSizeOuter(0))
        .call(g=>g.selectAll('g').remove())
        .call(g=>g.selectAll("path").remove())
      var yAxis = g => g
        .attr("transform", `translate(${width},0)`)
        .call(d3.axisLeft(y).ticks(null, "s"))
        .call(g => g.selectAll(".domain").remove())
        .call(g=>g.selectAll('line').remove())
        .call(g=>g.selectAll('text')
          .attr("font-weight", "400")
          .attr("font-size", "5px"))



      var svg = d3.select("#esg_risk_bar_chart").append("svg").attr("viewBox", [0, 0, width, height])
      svg.append('g')
        .call(xAxis)
        .call(yAxis)


      // 创建数组个数条折线
      var serie = svg.append("g")
        .selectAll("g")
        .data(series)
        .join("g")

      serie.append("path")
        .attr("fill", "none")
        .attr("stroke", d => color(d[0].key))
        .attr("stroke-width", 1)
        .attr("d", d3.line()
          .x(d => x(d.index))
          .y(d => y(d.value)));

      let tr = {
        "0": "近三年全行业险种平均赔付率"
      }
      let legend = svg => {
        const g = svg
          .attr("transform", `translate(${width-71},${height - 5})`)
          .attr("text-anchor", "end")
          .attr("font-family", "sans-serif")
          .attr("font-size", 4)
          .selectAll("g")
          .data(color.domain().slice().reverse())
          .join("g")
          .attr("transform", (d, i) => `translate(0,0)`);

        g.append("rect")
          .attr("x", 0)
          .attr("y",2)
          .attr("width", 8)
          .attr("height", 0.5)
          .attr("fill", color);

        g.append("text")
          .attr("x", 60)
          .attr("y", 4)
          .attr("dy", "0.035em")
          .text((d,i)=>tr[i])
      }
      svg.append("g").call(legend)

    },
    getData() {
      let all_data = JSON.parse(window.sessionStorage.getItem('esg_risk'))
      let bar_data = JSON.parse(all_data.insurance_type_data)
      this.broken_line_data = JSON.parse(all_data.insurance_ratio_data)

      this.formatData(bar_data)
    },
    // 将得到的柱状图的数据格式化
    formatData(data) {
      data = this.bar_columns.slice(1).map(key=>data.map(({[key] : value, insurance_type}) =>({key,insurance_type,value})))
      let m=data.length
      let n=data[0].length
      for(let i=0;i<m;i++){
        for(let j=0;j<n;j++){
          if(i==0) data[i][j]['value_last']=0
          else {
            data[i][j]['value_last']=data[i-1][j].value
            data[i][j].value = data[i][j].value_last + data[i][j].value
          }
        }
      }
      this.bar_data=data
    }
  },
  mounted() {
    this.getData()
    this.drawBarChart()
    this.drawBrokenLine()
  }
}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_bar_chart.js